// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline-container {
    position: absolute;
    display: flex;
    flex-direction: column;
    /* gap: 10px; */
    bottom: calc(1px + var(--safe-bottom));
    width: 100%;
    /* border-box so the padding eats into the 100%, rather than overflowing it. */
    box-sizing: border-box;
    padding-left: var(--safe-left);
    padding-right: var(--safe-right);
    /* height: 25%; */
    /* background-color: rgba(51, 51, 51, 0.7); */

    /* opacity: 0.; */
    /* border: solid; */
}`, "",{"version":3,"sources":["webpack://./src/burnair/modules/timeline/timeLine.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,sCAAsC;IACtC,WAAW;IACX,8EAA8E;IAC9E,sBAAsB;IACtB,8BAA8B;IAC9B,gCAAgC;IAChC,iBAAiB;IACjB,6CAA6C;;IAE7C,iBAAiB;IACjB,mBAAmB;AACvB","sourcesContent":[".timeline-container {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    /* gap: 10px; */\n    bottom: calc(1px + var(--safe-bottom));\n    width: 100%;\n    /* border-box so the padding eats into the 100%, rather than overflowing it. */\n    box-sizing: border-box;\n    padding-left: var(--safe-left);\n    padding-right: var(--safe-right);\n    /* height: 25%; */\n    /* background-color: rgba(51, 51, 51, 0.7); */\n\n    /* opacity: 0.; */\n    /* border: solid; */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
